import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ErrorObj } from "../utils/types";
import Test from "./PhoneOtpModal";
import PhoneOtpModal from "./PhoneOtpModal";
import EmailOtpModal from "./EmailOtpModal";
import greaterThan from '../assets/greaterthan.svg';

// Props type definition
interface DetailFormProps {
  userName: string;
  setUserName: (value: string) => void;
  phoneNumber: string;
  setPhoneNumber: (value: string) => void;
  email: string;
  setEmail: (value: string) => void;
  emailVerified: number;
  setEmailVerified: (value: any) => void;
  phoneVerified: number;
  setPhoneVerified: (value: any) => void;
  otpSent: boolean;
  setOtpSent: (value: boolean) => void;
  otp: string;
  setOtp: (value: string) => void;
  handleSendOtp: (choice: any) => void;
  handleOtpValidation: (choice: any) => void;
  handleSignup: () => void;
  isOtpMatched: boolean;
  setIsOtpMatched: (value: boolean) => void;
  password: string;
  setPassword: (value: string) => void;
  error: ErrorObj;
  setError: (value: any) => void;
  verifyError: string;
  setVerifyError: (value: any) => void;
  requestAccessLink: boolean;
}

const AuthDetailForm: React.FC<DetailFormProps> = ({
  userName,
  setUserName,
  phoneNumber,
  setPhoneNumber,
  email,
  setEmail,
  emailVerified,
  setEmailVerified,
  phoneVerified,
  setPhoneVerified,
  otpSent,
  setOtpSent,
  otp,
  setOtp,
  handleSendOtp,
  handleSignup,
  handleOtpValidation,
  isOtpMatched,
  setIsOtpMatched,
  password,
  setPassword,
  error,
  setError,
  verifyError,
  setVerifyError,
  requestAccessLink,
}) => {
  const [confirmPassword, setConfirmPassword] = useState("");
  const [phoneModalShow, setPhoneModalShow] = useState(false);
  const [emailModalShow, setEmailModalShow] = useState(false);

  const matchPassword = () => {
    setError({});
    if (confirmPassword !== password) {
      setError({
        confirmPassword: "Password does not match",
      });
      return false;
    } else {
      setError({});
      return true;
    }
  };

  const emailValidator = () => {
    setError({});
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!regex.test(email)) {
      setError({
        email: "Please enter a valid email address",
      });
      return false;
    }
    return true;
  };

  const phoneValidator = () => {
    setError({});
    if (phoneNumber.length !== 10) {
      setError({
        phone: "Enter valid 10 Digit Number",
      });
      return false;
    }
    if (!/^\d*$/.test(phoneNumber)) {
      setError({
        phone: "Please enter a valid phone number",
      });
      return false;
    }
    return true;
  };

  return (
    <>
      {error.system && (
        <p className="text-center mt-6 text-[#FF0000]" role="alert">
          {error.system}
        </p>
      )}
      {error.email && (
        <p className="text-center mt-6 text-[#FF0000]" role="alert">
          {error.email}
        </p>
      )}
      {error.password && (
        <p className="text-center mt-6 text-[#FF0000]" role="alert">
          {error.password}
        </p>
      )}
      {error.phone && (
        <p className="text-center mt-6 text-[#FF0000]" role="alert">
          {error.phone}
        </p>
      )}
      {error.confirmPassword && (
        <p className="text-center mt-6 text-[#FF0000]" role="alert">
          {error.confirmPassword}
        </p>
      )}
      {verifyError !== "" && (
        <p className="text-center mt-6 text-[#FF0000]" role="alert">
          {verifyError}
        </p>
      )}
      <>
        <label className="mt-4 sr-only" htmlFor="name">
          Enter your Name *
        </label>
        <div style={{ position: "relative" }}>
          <label className="signup-border-label">Name</label>
        </div>
        <input
          className="w-[100%] h-[3.625rem] px-4 mt-4 signup-input input-user"
          id="name"
          type="text"
          placeholder="New User"
          value={userName}
          onChange={(e) => {
            setUserName(e.target.value);
          }}
          aria-invalid={userName.length < 3}
        />
      </>
      <>
        <label htmlFor="email" className="mt-4 sr-only">
          Email
        </label>
        <div style={{ position: "relative" }}>
          <label className="signup-border-label">Email Address</label>
        </div>
        <input
          className="w-[100%] h-[3.625rem] px-4 mt-4 signup-input input-email"
          id="email"
          type="email"
          placeholder="user@gmail.com"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
          }}
          aria-invalid={error.email !== ""}
          readOnly={isOtpMatched && emailVerified === 2}
        />
        <div className="verification">
          <EmailOtpModal
            otpSent={otpSent}
            otp={otp}
            setOtp={setOtp}
            handleOtpValidation={handleOtpValidation}
            email={email}
            show={emailModalShow}
            setShow={setEmailModalShow}
            onHide={() => {
              setEmailModalShow(false);
              setOtp("");
              setOtpSent(false);
            }}
          />
          {email !== "" && emailVerified !== 2 && !otpSent && (
            <button
              onClick={() => {
                if (emailValidator()) {
                  setEmailModalShow(true);
                  handleSendOtp("email");
                }
              }}
              className="verify"
            >
              Verify E-mail
            </button>
          )}
          {emailVerified === 2 && (
            <p role="alert" className="verify success">
              Email verified successfully
            </p>
          )}
        </div>
      </>
      <>
        <label htmlFor="phonenumber" className="mt-4 sr-only">
          Phone Number
        </label>
        <div style={{ position: "relative" }}>
          <label className="signup-border-label">Mobile Number</label>
        </div>
        <input
          className="w-[100%] h-[3.625rem] px-4 mt-4 signup-input input-phone"
          id="phonenumber"
          type="tel" // Use 'tel' for better semantic and mobile keyboards
          value={phoneNumber}
          placeholder="XXXXXXXXXX"
          onChange={(e) => {
            setPhoneNumber(e.target.value);
          }}
          aria-invalid={error.phone !== ""}
          readOnly={isOtpMatched && phoneVerified === 2}
        />
        <div className="verification">
          <PhoneOtpModal
            show={phoneModalShow}
            setShow={setPhoneModalShow}
            onHide={() => {
              setPhoneModalShow(false);
              setOtp("");
              setOtpSent(false);
            }}
            otpSent={otpSent}
            otp={otp}
            setOtp={setOtp}
            handleOtpValidation={handleOtpValidation}
            phoneNumber={phoneNumber}
          />
          {phoneNumber !== "" && phoneVerified !== 2 && (
            <button
              onClick={() => {
                if (phoneValidator()) {
                  setPhoneModalShow(true);
                  handleSendOtp("phone");
                }
              }}
              className="verify"
            >
              Verify Mobile Number
            </button>
          )}
          {phoneVerified === 2 && (
            <p role="alert" className="verify success">
              Phone number verified successfully
            </p>
          )}
        </div>
      </>

      {/* Conditionally render the "Send OTP" button */}
      {/* {(phoneNumber || email) && !otpSent && !isOtpMatched && (
        <button
          onClick={handleSendOtp}
          className={`mt-6 ${
            emailValidator(email) || phoneNumber.length === 10
              ? "bg-[#4f00ec]"
              : "bg-gray-400"
          } w-[640px] h-[50px] rounded`}
          disabled={!emailValidator(email) && phoneNumber.length !== 10}
        >
          Send OTP
        </button>
      )} */}

      {/* Conditionally render the OTP input field */}

      {/* Conditionally render the password field , when OTP is validated */}

      <>
        <label htmlFor="password" className="mt-4 sr-only">
          Enter Password
        </label>
        <div style={{ position: "relative" }}>
          <label className="signup-border-label">Password</label>
        </div>
        <input
          className="w-[100%] h-[3.625rem] px-4 mt-4 signup-input input-password"
          id="password"
          type="password"
          placeholder="8+ characters"
          value={password}
          onChange={(e) => {
            setPassword(e.target.value);
          }}
          minLength={8} // Set minimum length to 8 characters
          required
        />
      </>

      <>
        <label htmlFor="cnfpassword" className="mt-4 sr-only">
          Confirm Password
        </label>
        <div style={{ position: "relative" }}>
          <label className="signup-border-label">Confirm Password</label>
        </div>
        <input
          className="w-[100%] h-[3.625rem] px-4 mt-4 signup-input input-password"
          id="cnfpassword"
          type="password"
          placeholder="8+ characters"
          value={confirmPassword}
          onChange={(e) => {
            setConfirmPassword(e.target.value);
          }}
          minLength={8} // Set minimum length to 8 characters
          required
        />
      </>
      <button
        className={`mt-12 bg-[#4f00ec] w-[11.25rem] h-[3.25rem] rounded submit-button`}
        onClick={() => {
          if (matchPassword()) {
            handleSignup();
          }
        }}
      >
        Signup
        <img src={greaterThan} alt="" aria-hidden="true" />
      </button>

      <div className="login-link-container">
        <h2 style={{ fontSize: "1rem", fontWeight: 500 }}
              className="mt-12 text-right mb-4">
          Already Have an account ?{" "}
          <Link to="/login" className="text-[#5030E5]" style={{textDecoration:"underline"}}>
            Login Here
          </Link>
        </h2>
      </div>


      <div className="mt-2 text-center">
        <p style={{ fontSize: "0.875rem", marginBottom: "0.5rem" }}>
          Available on IVR: <span style={{ fontWeight: 500 }}>+91-8035737222</span>
        </p>
        {/* <p style={{ fontSize: "0.875rem", color: "red" }}>
          WhatsApp service is temporarily down as we switch service providers.
        </p> */}
      </div>

      {requestAccessLink && (
        <p className="request-access-message mt-6">
          You are Not Authorized to use the system. You either need to enroll in
          Sugamya Pustakalaya, or{" "}
          <Link className="text-[#00DAF7]" to="/requestAccess">
            click here to verify your disability status
          </Link>
        </p>
      )}
      {/* <p className='mt-4'>{error}</p> */}
    </>
  );
};

export default AuthDetailForm;
